module.exports = __webpack_public_path__ + "static/media/ebookconversion.704699c0.svg";